<div
  class="modal fade"
  bsModal
  #staticModal="bs-modal"
  [config]="{ backdrop: 'static' }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="mySmallModalLabel"
  aria-hidden="true"
>
  <form (submit)="confirmEdit($event)" #completedForm="ngForm" ngNativeValidate>
    <div class="modal-dialog modal-md">
      <div class="modal-content panel-warning">
        <div class="modal-header panel-heading">
          <h4 class="modal-title pull-left">Edit Address</h4>
          <button
            type="button"
            class="close pull-right"
            aria-label="Close"
            (click)="close()"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <app-shared-address
            *ngIf="address"
            [model]="address"
            [requiredFields]="['address1', 'postalCode', 'country']"
          ></app-shared-address>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" (click)="close()">
            Cancel
          </button>
          <button type="submit" class="btn btn-success" (disabled)="disabled">Save</button>
        </div>
      </div>
    </div>
  </form>
</div>
